import { render, staticRenderFns } from "./g-drag-label.vue?vue&type=template&id=8fff4c4e&scoped=true&"
import script from "./g-drag-label.vue?vue&type=script&lang=ts&setup=true&"
export * from "./g-drag-label.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./g-drag-label.vue?vue&type=style&index=0&id=8fff4c4e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fff4c4e",
  null
  
)

export default component.exports